import { RigRateRangeBase } from './base/rig-rate-range-base';

export class RigRateRange extends RigRateRangeBase { }